/**
 * PaymentFooter — Stripe trust signal + accepted payment methods.
 * Text-only for v1.
 */

import { ShieldCheck } from 'lucide-react';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from './legalLinks';

export function PaymentFooter() {
  return (
    <footer className="mt-8 text-center space-y-1">
      <p className="flex items-center justify-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
        <ShieldCheck className="h-4 w-4 text-gray-400" aria-hidden="true" />
        Secure payment powered by Stripe
      </p>
      <p className="text-xs text-gray-400">
        We accept Visa, Mastercard, Amex, ACH, Apple Pay, Google Pay
      </p>
      <p className="text-xs text-gray-400 space-x-2">
        <a
          href={TERMS_OF_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gray-600 dark:hover:text-gray-300"
        >
          Terms of Service
        </a>
        <span aria-hidden="true">&middot;</span>
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gray-600 dark:hover:text-gray-300"
        >
          Privacy Policy
        </a>
      </p>
    </footer>
  );
}
